import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';

const NotFound: React.FC = () => {
  return (
    <>
      <SEO
        title="404 | Ambi Suzanne Brenner"
        description="The page you are looking for does not exist."
        url={`${process.env.REACT_APP_SITE_URL}/404`}
      />

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="max-w-[52rem] mx-auto"
      >
        <div className="w-full max-w-[52rem] mx-auto">
          <motion.div
            initial={{ y: -20 }}
            animate={{ y: 0 }}
            transition={{ delay: 0.2 }}
            className="bg-white rounded-xl shadow-lg overflow-hidden"
          >
            <div className="p-8 md:p-10 pb-0 text-center">
              <h1 className="text-3xl font-bold text-gray-900 mb-3">404</h1>
              <p className="text-gray-600 text-xl mb-6">
                The page you’re looking for can’t be found.
              </p>
            </div>
            <div className="grid grid-cols-2">
              <Link 
                to="/" 
                className="w-full py-4 text-sm font-semibold text-white bg-[#638fd8] hover:bg-[#7B9AD2] transition-colors duration-200 text-center uppercase tracking-wider rounded-bl-xl"
              >
                Go Home
              </Link>
              <Link 
                to="/contact" 
                className="w-full py-4 text-sm font-semibold text-white bg-[#4b5563] hover:bg-[#374151] transition-colors duration-200 text-center uppercase tracking-wider rounded-br-xl"
              >
                Contact Me
              </Link>
            </div>
          </motion.div>
        </div>
      </motion.div>
    </>
  );
};

export default NotFound;


